import { connect } from 'react-redux';
import { selectIsDesktop } from 'selectors/ui';
import Dropdown from './Dropdown';

function mapStateToProps(state, ownProps) {
  return {
    isDesktop: selectIsDesktop(state),
    ...ownProps,
  };
}

export default connect(mapStateToProps)(Dropdown);
